import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submodule-passed',
  templateUrl: './submodule-passed.component.html',
  styleUrls: ['./submodule-passed.component.scss']
})
export class SubmodulePassedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
